import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class LegalsService extends BaseService {

    static url = "legals";
    static apis = {
        getAll: { path: this.url, method: "get" },
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("legals");
    }

    getAll() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: LegalsService.apis.getAll.path,
                    method: LegalsService.apis.getAll.method,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

}

export default LegalsService;